import { SpwkUtilV3 } from "../dao/SpwkUtilV3";
import { new_ErrorAlert } from "./ExportManager";
import { GovRow } from "./GovRow";
import { SpwkGovStep } from "./GovRowHelper";
import { A98申報解碼, 填寫申報文字答題1到4, 申報通用解碼 } from "./GovRowParser_既往病史_自覺症狀";
import { HisBasic } from "./HisBasic";
import { SpwkMetaData } from "./SpwkMetaData";
import { SpwkMetaTable } from "./SpwkMetaTable";


export class GovRowParser_作業經歷 {

  static ConvertToHisRow(func_guid: string, func_code: string, step: SpwkGovStep, 基本檔: HisBasic, meta_table: SpwkMetaTable): GovRow[] {

    if (step.Chapter !== SpwkUtilV3.CHAPTER_作業經歷) {
      throw new Error("4984651 必須是 CHAPTER_作業經歷 !!!");
    }

    if (func_code === SpwkUtilV3.A01_func_guid) {
      throw new_ErrorAlert("4684143 A01 還沒有轉申報格式 !!!")
    }

    let re: GovRow[] = [];

    let q_meta_list = meta_table.FilterQuestions_ByChapter(SpwkUtilV3.CHAPTER_作業經歷);
    let shift_work: SpwkMetaData | undefined
    let work_time: SpwkMetaData | undefined
    for (const q_meta of q_meta_list) {
      if (q_meta.q_gov_code == null || q_meta.q_gov_code === "") {
        if (func_guid === SpwkUtilV3.A98_func_guid) {//yao 26~83 132~215
          //yao ToDo 之後改成不要寫死
          if (q_meta.code === '輪班') {
            shift_work = q_meta
          }
          if (q_meta.code === '工作時段') {
            work_time = q_meta
          }
          if (shift_work && work_time) {
            const no_shift: GovRow = new GovRow(基本檔, step.Gov問卷類別);//不用輪班的gov_row
            const shift: GovRow = new GovRow(基本檔, step.Gov問卷類別);//輪班的gov_row
            const shift_work_times: GovRow = new GovRow(基本檔, step.Gov問卷類別);//輪班時段的gov_row

            no_shift.問題編號 = '0401'
            shift.問題編號 = '040201'
            shift_work_times.問題編號 = '040202'
            if (shift_work.rhf_value !== '固定') {
              A98取得上下班時間(shift_work_times, work_time, meta_table);
              no_shift.答題內容 = "00000"
              switch (shift_work.rhf_value) {
                case "兩班":
                  shift.答題內容 = "11000"
                  break;
                case "三班":
                  shift.答題內容 = "10100"
                  break;
                case "四班":
                  shift.答題內容 = "10010"
                  break;
                case "其他":
                  shift.答題內容 = "10001"
                  填寫申報文字答題1到4(shift, shift_work, meta_table)
                  break;
                default:
                  throw new_ErrorAlert('5693482 預期外的選項')

              }
            } else {
              A98取得上下班時間(no_shift, work_time, meta_table);
              no_shift.答題內容 = `1${no_shift.答題內容}`
              shift.答題內容 = "00000"
              shift_work_times.答題內容 = "0000"
            }
            re.push(no_shift)
            re.push(shift)
            re.push(shift_work_times)
          }

          continue;  // pass; 目前不處理沒有指定申報代碼的題目
        } else {
          continue;  // pass; 目前不處理沒有指定申報代碼的題目
        }
      }

      if (func_guid === SpwkUtilV3.B02_func_guid) {// 使用 B02 解碼規則
        const gov_row = 申報通用解碼(q_meta, 基本檔, step, meta_table);
        re.push(gov_row);
      } else if (func_guid === SpwkUtilV3.A98_func_guid) {
        //yao
        const gov_row = A98申報解碼(q_meta, 基本檔, step, meta_table);
        re.push(gov_row);
      }
      else if (q_meta.func_code === SpwkUtilV3.FUNC_CODE_A01) {// 使用 B01 解碼規則
        if (q_meta.q_gov_code === "03" && q_meta.code.endsWith("_平均每日工時")) {// 使用 _平均每日工時 規則

          const gov_row: GovRow = new GovRow(基本檔, step.Gov問卷類別);
          gov_row.問題編號 = q_meta.q_gov_code;
          gov_row.答題內容 = "1";// _平均每日工時 總是填 1

          填寫申報文字答題1到4(gov_row, q_meta, meta_table);

          re.push(gov_row);
        } else {
          const gov_row = 申報通用解碼(q_meta, 基本檔, step, meta_table);
          if (gov_row.問題編號 === '04' && gov_row.答題內容 === '10') {
            gov_row.答題內容 = '1'
          } else if (gov_row.問題編號 === '04' && gov_row.答題內容 === '01') {
            gov_row.答題內容 = ''
          }
          re.push(gov_row);
        }
      }
      else {
        if (q_meta.q_gov_code === "03" && q_meta.code.endsWith("_平均每日工時")) {// 使用 _平均每日工時 規則

          const gov_row: GovRow = new GovRow(基本檔, step.Gov問卷類別);
          gov_row.問題編號 = q_meta.q_gov_code;
          gov_row.答題內容 = "1";// _平均每日工時 總是填 1

          填寫申報文字答題1到4(gov_row, q_meta, meta_table);

          re.push(gov_row);

        } else {
          const gov_row = 申報通用解碼(q_meta, 基本檔, step, meta_table);
          re.push(gov_row);
        }
      }

    }
    //A98依照問題編號重新排序
    if (func_guid === SpwkUtilV3.A98_func_guid) {
      re.sort(function sortby問題編號(a, b) {
        let sorta: number = +a.問題編號
        let sortb: number = +b.問題編號
        return sorta - sortb
      })
    }
    return re;
  }

}
function A98取得上下班時間(gov_row: GovRow, q_meta: SpwkMetaData, meta_table: SpwkMetaTable) {

  let input_meta_list: SpwkMetaData[] = [];
  if (q_meta.kind === SpwkUtilV3.Q_KIND_多選 || q_meta.kind === SpwkUtilV3.Q_KIND_非選) {

    input_meta_list = meta_table.FilterInputs_ByQuestionGuid(q_meta.question_guid);
  } else if (q_meta.kind === SpwkUtilV3.Q_KIND_單選) {

    let find_opt_meta = meta_table.FindRadioOptionMeta(q_meta);

    if (find_opt_meta != null) {
      input_meta_list = meta_table.FilterInputs_ByOptionGuid(find_opt_meta.data_guid);

    } else {
      if (q_meta.rhf_value == null || q_meta.rhf_value === "") {
        input_meta_list = [];// pass 尚未勾選
      } else {
        throw new_ErrorAlert("66514648 找不到 opt_meta !!!\nq_meta.data_guid= " + q_meta.data_guid + "\n" + q_meta.getDebugDisplayCode());
      }
    }

  } else {
    throw new_ErrorAlert("1465432 必須是單選 或 多選 !!!\nq_meta.data_guid: " + q_meta.data_guid + "\n" + q_meta.getDebugDisplayCode());
  }
  for (const inp_meta of input_meta_list) {
    let n = parseInt(inp_meta.i_gov_code);
    if (isNaN(n)) {
      throw new_ErrorAlert("4341686 申報選項必須有 o_gov_code 且為數字 !!!\n題目: q_meta:" + q_meta.getDebugDisplayCode() + "\ninp_meta.data_guid: " + inp_meta.data_guid);
    }
    let rhf_value = inp_meta.rhf_value ?? "";
    if (n === 1) {
      if (gov_row.答題內容_1) {
        gov_row.答題內容_2 = getTimeOnly(rhf_value)
      } else {
        gov_row.答題內容_1 = getTimeOnly(rhf_value);
      }
    } else if (n === 2) {
      gov_row.答題內容_2 = rhf_value;
    } else if (n === 3) {
      gov_row.答題內容_3 = rhf_value;
    } else if (n === 4) {
      gov_row.答題內容_4 = rhf_value;
    } else {
      throw new_ErrorAlert("494916 答題內容_1~4 index超出範圍 !!!\ninp_meta.data_guid: " + inp_meta.data_guid);
    }

  }
  gov_row.答題內容 = getGovValue(gov_row)
}
function getTimeOnly(dateTimeStr: string): string {
  const dateTime = new Date(dateTimeStr);
  const hours = dateTime.getHours().toString().padStart(2, '0');
  const minutes = dateTime.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}`;
}

function getGovValue(gov_row: GovRow): string {
  let startGov = getTimeGov(gov_row.答題內容_1)
  let endGov = getTimeGov(gov_row.答題內容_2)
  return `${startGov}${endGov}`
}


function getTimeGov(time: string) {
  const dateTime = new Date(`2000-01-01 ${time}:00`);
  const hours = dateTime.getHours();

  if (hours >= 0 && hours < 12) {
    return '10';
  } else {
    return '01';
  }
}

